import { AddIcon } from "@chakra-ui/icons";
import { Flex, Text, Button } from "@chakra-ui/react";
import React from "react";
import { FiEdit2 } from "react-icons/fi";
import { SettingRowBase } from "./SettingRowBase";

interface EditValueSettingRowProps {
  label: string;
  description?: string;
  value?: string;
  action?: () => void;
  canEdit: boolean;
}

export function EditValueSettingRow({
  label,
  description,
  value,
  canEdit,
  action,
}: EditValueSettingRowProps) {
  return (
    <SettingRowBase label={label} description={description}>
      <Flex w="full" alignItems="flex-start" gap={3} wrap="wrap">
        {value && <Text>{value}</Text>}

        {canEdit && (
          <Button
            leftIcon={value ? <FiEdit2 /> : <AddIcon />}
            variant="outline"
            backgroundColor="white"
            size="sm"
            onClick={action}
          >
            {value ? "Edit" : "Add"}
          </Button>
        )}
      </Flex>
    </SettingRowBase>
  );
}
